// Breakpoints de viewport — mesmos thresholds usados pelo mixin
// `componentesProcessamento.js` (screen_xs/screen_sm). Mantidos aqui pra
// componentes que não vivem dentro do mixin (ex.: PopUpComponent).
//
// Se mudar aqui, alinhar lá também — TODO: convergir o mixin pra consumir
// daqui em vez de manter cópia.
export const VIEWPORT_BREAKPOINTS = {
  mobile: 520, // ≤ 520 → "M"
  tablet: 768, // 521–768 → "T"; > 768 → "D"
};

// Retorna o token de viewport atual: "D" (desktop), "T" (tablet), "M" (mobile).
// SSR-safe: retorna "D" quando `window` não existe.
export function detectViewport() {
  if (typeof window === "undefined") return "D";
  const w = window.innerWidth;
  if (w <= VIEWPORT_BREAKPOINTS.mobile) return "M";
  if (w <= VIEWPORT_BREAKPOINTS.tablet) return "T";
  return "D";
}
